import {useAppContext} from "../../utils/AppContext";

const Waitlist = () => {
    const {
        projectData,
        screenSize,
        waitlistEmail,
        handleSetWaitlistEmail,
        waitlistResult,
        waitlistError,
        handleJoinWaitlist
    } = useAppContext();

    // Styles Configuration //
    const waitlistContainer = (!screenSize)? 'waitlist-container' : `waitlist-container waitlist-container${screenSize}`;
    const largeTextLight = (!screenSize)? "large-text-light" : `large-text-light large-text-light${screenSize}`;
    const waitlistEmailInputContainer = (!screenSize)? "waitlist-email-input-container" : `waitlist-email-input-container waitlist-email-input-container${screenSize}`;
    const waitlistEmailInput = (!screenSize)? "waitlist-email-input input-text" : `waitlist-email-input waitlist-email-input${screenSize} input-text input-text${screenSize}`;
    const smallTextLight = (!screenSize)? "small-text-light" : `small-text-light small-text-light${screenSize}`;
    const primaryButton = (!screenSize)? "primary-button" : `primary-button primary-button${screenSize}`;
    const primaryButtonText = (!screenSize)? "primary-button-text" : `primary-button-text primary-button-text${screenSize}`;

    return (
        <div className={waitlistContainer}>
            <p className={largeTextLight}>{projectData.pricing.plans[0].description}</p>
            <div className={waitlistEmailInputContainer}>
                <input
                    className={waitlistEmailInput}
                    type="email"
                    placeholder="Enter your email"
                    onChange={(e) => handleSetWaitlistEmail(e.target.value)}
                />
                <button 
                    className={primaryButton}
                    onClick={() => handleJoinWaitlist(waitlistEmail)}
                >
                    <span className={primaryButtonText}>{projectData.pricing.plans[0].cta}</span>
                </button>
            </div>
            {waitlistResult === true && <span className="small-text-success">You're already subscribed</span>}
            {waitlistResult === false && <span className="small-text-success">Thanks for subscribing!</span>}
            {waitlistError && <span className="small-text-error">{waitlistError}</span>}
            <span className={smallTextLight}>{projectData.pricing.offer_nudge}</span>
        </div>
    );
};

const PaidPlans = () => {
    const {
        projectData,
        screenSize,
        isMediumScreen, isSmallScreen,
    } = useAppContext();

    // Styles Configuration //
    const offerPlansContainer = (!screenSize)? 'offer-plans-container' : `offer-plans-container offer-plans-container${screenSize}`;
    const offerPlanContainer = (!screenSize)? "offer-plan-container" : `offer-plan-container offer-plan-container${screenSize}`;
    const planItemContent = (!screenSize)? "plan-item-content" : `plan-item-content plan-item-content${screenSize}`;
    const planItemTopSection = (!screenSize)? "plan-item-top-section" : `plan-item-top-section plan-item-top-section${screenSize}`;
    const itemTitle = (!screenSize)? "item-title" : `item-title item-title${screenSize}`;
    const smallTextLight = (!screenSize)? "small-text-light" : `small-text-light small-text-light${screenSize}`;
    const largeNumber = (!screenSize)? "large-number" : `large-number large-number${screenSize}`;
    const planItemFeaturesContainer = (!screenSize)? "plan-item-features-container" : `plan-item-features-container plan-item-features-container${screenSize}`;
    const planItemFeature = (!screenSize)? "plan-item-feature" : `plan-item-feature plan-item-feature${screenSize}`;
    const planCtaButtonContainer = (!screenSize)? "plan-cta-button-container" : `plan-cta-button-container plan-cta-button-container${screenSize}`;
    const primaryButton = (!screenSize)? "primary-button cta-button" : `primary-button cta-button${screenSize} primary-button${screenSize}`;
    const primaryButtonText = (!screenSize)? "primary-button-text" : `primary-button-text primary-button-text${screenSize}`;

    const renderFeature = ({item, index}) => (
        <div 
            className={planItemFeature}
            key={index}
        >
            <span className={smallTextLight}>&#10003;</span>
            <p className={smallTextLight}>{item}</p>
        </div>
    );

    const renderPlan = ({item, index}) => (
        <div 
            className={offerPlanContainer}
            key={index}
        >
            <div className={planItemContent}>
                <div className={planItemTopSection}>
                    <h4 className={itemTitle}>{item.name}</h4>
                    <p className={smallTextLight}>{item.description}</p>
                    <span className={largeNumber}>{item.price}</span>
                </div>
                <div className={planItemFeaturesContainer}>
                    {projectData.pricing.plans[index].features.map((featureItem, featureIndex) => (
                        renderFeature({item: featureItem, index: featureIndex})
                    ))}
                </div>
            </div>
            <div className={planCtaButtonContainer}>
                <button className={primaryButton}>
                    <span className={primaryButtonText}>{item.cta}</span>
                </button>
            </div>
        </div>
    );

    return (
        <>
            {!(isMediumScreen || isSmallScreen)?
                <div className={offerPlansContainer}>
                    <div className="offer-plans-scroll">
                        {projectData.pricing.plans.map((item, index) => (
                            renderPlan({item, index})
                        ))}
                    </div>
                </div>
            :
                <div className={offerPlansContainer}>
                    {projectData.pricing.plans.map((item, index) => (
                        renderPlan({item, index})
                    ))}
                </div>
            }
        </>
    );
};

const Offer = () => {
    const {
        projectData,
        screenSize,
    } = useAppContext();

    // Styles Configuration //
    const offerContainer = (!screenSize)? 'offer-container' : `offer-container offer-container${screenSize}`;
    const sectionTitle = (!screenSize)? "section-title scroll-section-title" : `section-title scroll-section-title${screenSize} section-title${screenSize}`;

    return (
        <div className={offerContainer}>
            <h2 className={sectionTitle}>{projectData.pricing.title}</h2>
            {projectData.pricing.type === "Waitlist" && <Waitlist/>}
            {projectData.pricing.type === "Paid" && <PaidPlans/>}
        </div>
    );

};

export default Offer;
